// extracted by mini-css-extract-plugin
export var productImage = "_q2-1";
export var viewLink = "_q2-2";
export var wishlistItem = "_q2-0";